autoOpenDrawer();

async function autoOpenDrawer() {
	const cartData = await getCartData();
	const products = window.openCartProducts;
	if (cartData.item_count > 0) {
		products.forEach((product) => {
			if (cartData.items.some((item) => item.product_id === product.id)) {
				checkAndRenderDrawer();
				document.querySelector("cart-drawer").open(this);
			}
		});
	}
}

// Return cart data as JSON
async function getCartData() {
	const response = await fetch(`${routes.cart_url}.js`);
	const data = await response.json();
	return data;
}

let checkCount = 1;
async function checkAndRenderDrawer() {
	await renderCartDrawer();
	const cartDrawer = document.querySelector("cart-drawer");
	if (cartDrawer.classList.contains("is-empty") || checkCount > 20) {
		setTimeout(() => {
			checkCount++;
			checkAndRenderDrawer();
		}, 300);
	}
}

// Section API Reload Cart-Drawer
async function renderCartDrawer() {
	// Update Cart Drawer
	fetch(window.Shopify.routes.root + "?sections=cart-drawer")
		.then((res) => res.json()) // Parse the response as JSON
		.then((data) => {
			const cartDrawer = document.querySelector("cart-drawer");
			// Convert the HTML string into a document object that can be parsed to replace the cart drawer
			const parser = new DOMParser();
			const doc = parser.parseFromString(data["cart-drawer"], "text/html");
			// Get the new cart drawer and replace the existing one, and check if is empty to add class
			cartDrawer.querySelector(".drawer__inner").replaceWith(doc.querySelector(".drawer__inner"));
			if (doc.querySelector("cart-drawer").classList.contains("is-empty")) {
				cartDrawer.classList.add("is-empty");
			} else {
				cartDrawer.classList.remove("is-empty");
			}
		})
		.catch((error) => {
			console.error("Error reloading cart drawer: ", error);
		});
	// Update Cart Icon Bubble
	fetch(window.Shopify.routes.root + "?sections=cart-icon-bubble")
		.then((res) => res.json()) // Parse the response as JSON
		.then((data) => {
			const cartIconBubble = document.querySelector("#cart-icon-bubble");
			// Convert the HTML string into a document object that can be parsed to replace the cart drawer
			const parser = new DOMParser();
			const doc = parser.parseFromString(data["cart-icon-bubble"], "text/html");
			// Get the new cart drawer and replace the existing one, and check if is empty to add class
			cartIconBubble.innerHTML = doc.querySelector(".shopify-section").innerHTML;
		})
		.catch((error) => {
			console.error("Error reloading cart bubble count: ", error);
		});
}
